<template>
  <div class="check-work-body">

    <!-- 搜索 -->
    <div class="search-wrap">
      <el-select v-model="area_id" clearable placeholder="请选择考勤点" size="mini">
        <el-option v-for="item in areaList" :key="item.area_id" :label="item.area_name" :value="item.area_id"></el-option>
      </el-select>
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="getList()" :loading="searchLoading">搜索</el-button>
    </div>

    <!-- 员工列表 -->
    <div class="table-wrap">
      <el-table v-loading="searchLoading" :data="tableData">
        <el-table-column prop="user_name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="sex_text" label="性别" align="center"></el-table-column>
        <el-table-column prop="phone_number" label="手机号" align="center"></el-table-column>
        <el-table-column prop="area_name" label="考勤点" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-date" @click="showDialog(scope.row)">排班列表</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
    </div>

    <!-- 排班列表窗口 -->
    <el-dialog title="排班列表" :visible.sync="dialogVisible" top="5vh" :close-on-click-modal="true" width="800px">

      <erp-calendar v-model="date" @selectDate="selectDate">
        <template slot="headerCenter">
          <div class="calendar-center">
            计划出勤天数：{{month_length}}
          </div>
        </template>
        <template slot="dateCell" slot-scope="{date, data}">
          <div class="dateCell" >
            <p class="dateCell-text">
              {{ data.day.split('-').slice(2).join('') }}
            </p>
            <p class="dateCell-icon" :class="(date_list[data.day]||{}).work_check_type!=='workday' ? '' : 'is-selected'" :type="data.type">
              {{ (date_list[data.day]||{}).work_check_type!=='workday' ? '' : '✔'}}
            </p>
            <p class="dateCell-sub" :class="(date_list[data.day]||{}).work_check_type!=='workday' ? '' : 'is-selected'">
              {{ (date_list[data.day]||{}).class_name}}-{{(date_list[data.day]||{}).class_short_name}}
            </p>
          </div>

        </template>
      </erp-calendar>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import { DateFormat, Admin, User } from './common.js'
  import erpCalendar from "../Common/erp-calendar/src/main";

export default {
  name: "check-work-admin",
  components:{erpCalendar},
  data() {
    return{
      keyword: '',
      searchLoading: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      area_id: '',
      areaList: [],
      dialogVisible: false,
      date: new Date(),
      date_list:{},
      _date_list_:[],
      userObj:{},
      month_length:0
    }
  },
  watch: {
    date(date) {
      this.getClassList()
    },
  },
  activated() {
    let query = this.$route.query
    if(query.area_id && query.area_id != this.area_id) {
      this.area_id = Number(query.area_id)
      this.getList()
    }
  },
  mounted() {

    let query = this.$route.query
    if(query.area_id) {
      this.area_id = Number(query.area_id)
    }
    this.getList()

    Admin.getAreaList(res => {
      console.log(res)
      if(res.code == 0) {
        this.areaList = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

  },
  methods:{

    pageChange(i) {
      this.page = i
      this.getList()
    },

    getList() {
      this.searchLoading = true
      User.getList({area_id: this.area_id, keyword: this.keyword, page: this.page, page_size: this.pageSize}, res => {
        this.total = res.data.total
        this.tableData = res.data.list ? res.data.list.map(item => {
          item.sex_text = User.getSexText(item.sex)
          return item
        }) : []
        this.searchLoading = false
      })
    },

    showDialog(item) {
      var that=this;
      that.userObj=item;
      this.getUserWorkClass(Dateformat("yyyy-MM"))

      this.dialogVisible = true
    },

    hideDialog() {
      this.dialogVisible = false
    },

    selectDate(day) {
      console.log(day)
      let month=day.slice(0,7);
      console.log(day,month)
      this.getUserWorkClass(month)

    },

    getClassList() {

    },

    getUserWorkClass(month='2022-08'){
      var that=this;
      let item=that.userObj;
      User.getUserWorkClass({user_id:item.user_id,area_id:item.area_id,month:month},ret=>{
        let a = {}
        ret.data.map(ret=>{
          a[ret.work_date]=ret;
        })
        that.month_length=ret.data.filter(ret=>{
          return ret.work_check_type=='workday'
        }).length
        that.date_list=a
      })
    }

    // end methods
  },
}

function Dateformat(fmt,time=null) {
  let d=time?new Date(time):new Date();
    let o = {
      "M+": d.getMonth() + 1, //月份
      "d+": d.getDate(), //日
      "h+": d.getHours(), //小时
      "m+": d.getMinutes(), //分
      "s+": d.getSeconds(), //秒
      "q+": Math.floor((d.getMonth() + 3) / 3), //季度
      "S": d.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }
</script>

<style lang="scss" scoped>
  @import './common.scss';

  /* 除去日历表格的padding */
  /deep/.el-calendar-table .el-calendar-day {
    height: auto;
    padding: 0;
  }

  .dateCell{
    .dateCell-text{
      font-size: 18px;
    }
    .dateCell-icon{
      text-align: center;
      font-size: 22px;

      &.is-selected{
        color: #42a936;
      }
    }
    .dateCell-sub{
      text-align: center;
      font-size: 10px;
      color: #FF9900;

      &.is-selected{
        color: #42a936;
      }
    }
  }
  .calendar-center{
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/CheckWorkUser.vue